import Slick from '../plugins/slick.js';

jQuery(function($) {
  // Anchor
  $('a').on('click', function(e){
    var $href = $(this).attr('href');
    if ($href.match('^#') && !$(this).hasClass('accordion-tab')) {
      e.preventDefault();
      $('html, body').stop().animate({
          scrollTop: $($href).offset().top
      });
    }
  });

  // .btn SVGs
  document.querySelectorAll('a.btn').forEach(btn => {
    btn.insertAdjacentHTML('beforeend', `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none">
    <path d="M0.5 6.20698H13.875M13.875 6.20698L8.27496 0.707092M13.875 6.20698L8.27496 11.7071" stroke="white" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
  </svg>`);
  });

  // Video popups
  $('a').on('click', function(e){
    var $target = $(this).attr('href');
    if ($target.toLowerCase().indexOf("vimeo") >= 0) {
      e.preventDefault();
      var $n = $target.lastIndexOf('/');
      var $vid = $target.substring($n + 1);
      $('.popup-content').html('<iframe src="https://player.vimeo.com/video/' + $vid + '/?autoplay=1&api=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
      $('.video-popup-wrapper').addClass('active');
      $('body, html').addClass('body-noscroll');
    }
    if ($target.toLowerCase().indexOf("youtu") >= 0) {
      e.preventDefault();
      var $y = $target.lastIndexOf('=');
      var $yid = $target.substring($y + 1);
      $('.popup-content').html('<iframe src="https://www.youtube.com/embed/' + $yid + '/?autoplay=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
      $('.video-popup-wrapper').addClass('active');
      $('body, html').addClass('body-noscroll');
    }
  });
  $('.close-popup').on('click', function(){
    $('.video-popup-wrapper').removeClass('active');
    $('.popup-content').html('');
    $('body, html').removeClass('body-noscroll');
  });

  // Mobile Nav
  var $scrollposition = 0;
  $('#mobile-nav-toggle').on('click', function(){
    if ($(this).hasClass('active')) {
      $('body, html').removeClass('nav-locked');
      $(window).scrollTop($scrollposition);
    } else {
      $scrollposition = $(window).scrollTop();
      $('body, html').addClass('nav-locked');
      $(window).scrollTop(0);
    }
    $('#mobile-navigation-wrapper').toggleClass('active');
    $(this).toggleClass('active');
  });

  var scroll_actions = function() {
    $('.loading').each(function(){
      $(this).addClass('loaded');
    });
    for (var i = 0; i <= 21; i++) {
      var selector = i === 0 ? '.animate' : '.animate-' + i;
      var delay = i * 100;
      $(selector).each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){ $this.addClass('visible'); }, delay);
        }
      });
    }
  };

  $(window).on('load', function(){
    $(window).trigger('resize');
    setTimeout(function(){ $(window).trigger('resize'); }, 500);
    scroll_actions();
  });
  $(document).ready(scroll_actions);
  $(window).on('scroll', scroll_actions);

  // Work image carousel popup
  if ($('.work-image-carousel').length) {
    $('.work-image-carousel').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      adaptiveHeight: true,
    });

    $('.work-post-body').on('click', '.image-wrapper', function() {
      var index = parseInt($(this).find('img').data('carousel-index')) || 0;
      $('#work-carousel-popup').addClass('active');
      $('body, html').addClass('body-noscroll');
      $('.work-image-carousel').slick('slickGoTo', index, true);
    });

    $('#work-carousel-popup .work-carousel-close, #work-carousel-popup .work-carousel-overlay').on('click', function() {
      $('#work-carousel-popup').removeClass('active');
      $('body, html').removeClass('body-noscroll');
    });

    $(document).on('keydown', function(e) {
      if (e.key === 'Escape') {
        $('#work-carousel-popup').removeClass('active');
        $('body, html').removeClass('body-noscroll');
      }
    });
  }

});